<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		class?: string;
		gridClass?: string;
		children?: Snippet;
	}

	let { class: className, gridClass, children }: Props = $props();
</script>

<div class="w-full lg:mx-auto lg:max-w-[1408px]{className ? ` ${className}` : ''}">
	<div class="lg:grid lg:grid-cols-12 lg:gap-x-6 lg:mx-[18px]{gridClass ? ` ${gridClass}` : ''}">
		{@render children?.()}
	</div>
</div>
